var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-rss-icon';
                    var viewUrl = 'gfx/sprite.svg#view-icon-rss-icon';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 50 50',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };